import { fetchTasks } from 'api/documents'
import { DEFAULT_PER_PAGE, LOCAL_STORAGE_KEYS } from 'config'
import { useRouteLoaderData, redirect } from 'react-router-dom'

export async function baseLoader() {
  const data = (await fetchTasks([])).map((d) => ({
    ...d,
    perPage: d.perPage || DEFAULT_PER_PAGE,
  }))
  return { baseData: data }
}

type DocumentListSearchParams = {
  page: string
  perPage: string
}

const INIT_SEARCH_PARAMS: DocumentListSearchParams = {
  page: '',
  perPage: '',
}

export async function loader({ request, params }: any) {
  const url = new URL(request.url)
  const urlSearchParams = Object.fromEntries(url.searchParams)
  const localStoragePerPage =
    localStorage.getItem(LOCAL_STORAGE_KEYS.documentListPerPage) ||
    String(DEFAULT_PER_PAGE)
  const searchParams: DocumentListSearchParams = {
    ...INIT_SEARCH_PARAMS,
    ...urlSearchParams,
    ...{ perPage: localStoragePerPage },
  }
  const type = parseInt(params.type)
  if (isNaN(type)) {
    throw Error('type is not a number')
  }

  const data = await fetchTasks({ ...searchParams, type })
  if (!data[0].perPage) data[0].perPage = DEFAULT_PER_PAGE
  const page = parseInt(searchParams.page) || 0
  const perPage = parseInt(searchParams.perPage)
  const total = data[0].total
  if (searchParams.page && page !== 0 && page * perPage >= total) {
    url.searchParams.set(
      'page',
      String(total === 0 ? 0 : Math.ceil(total / perPage) - 1),
    )
    return redirect('.?' + url.searchParams.toString()) // eslint-disable-line prefer-template
  }
  return {
    data: data[0],
    page: page,
    perPage: perPage,
    type,
  }
}

export function useVerifyHomeBaseLoaderData() {
  return useRouteLoaderData('home') as Exclude<
    Awaited<ReturnType<typeof baseLoader>>,
    Response
  >
}

export function useVerifyHomeLoaderData() {
  return useRouteLoaderData('verifyhome') as Exclude<
    Awaited<ReturnType<typeof loader>>,
    Response
  >
}
